import ApiService from "../services/api-service";
import { slugify } from "./slug";

// Fetched once at module load and shared by every page (Home, Liked, user
// profiles) so they all show the exact same category list. Top-level await
// modules are cached, so importing this from multiple files only fetches once.
export const CATEGORIES: any[] = await (async () => {
  try {
    const response = await ApiService.getAllCategories();
    // An unreachable or misconfigured API can answer without a list; every
    // importer calls array methods on this at load time.
    return Array.isArray(response?.categories) ? response.categories : [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
})();

// Category id 1 is the "All" entry; every page treats it as "no filter".
const ALL_CATEGORY_ID = "1";

const categorySlug = (category: any): string =>
  String(category?._id || slugify(String(category?.name || "")) || category?.id || "");

// Resolves a URL segment (a slug like "mindset", or a legacy numeric id) to
// the category id string used by the feed filters; unknown values -> "all".
export function categoryIdFromParam(param: string | null | undefined): string {
  if (!param) return "all";
  const value = decodeURIComponent(param).trim().toLowerCase();
  const match = CATEGORIES.find(
    (category: any) => categorySlug(category).toLowerCase() === value || String(category.id) === value
  );
  if (!match || String(match.id) === ALL_CATEGORY_ID) return "all";
  return String(match.id);
}

// The inverse: category id -> slug for the URL, or null for "all".
export function categoryParamFromId(categoryId: string | number | null | undefined): string | null {
  const id = String(categoryId ?? "all");
  if (id === "all" || id === ALL_CATEGORY_ID) return null;
  const match = CATEGORIES.find((category: any) => String(category.id) === id);
  return match ? categorySlug(match) : id;
}

export function categoryNameFromId(categoryId: string | number | null | undefined): string | null {
  const match = CATEGORIES.find((category: any) => String(category.id) === String(categoryId));
  return match?.name ?? null;
}
